import React, { SVGProps } from "react";

type Variation = "normal" | "thick";

const CloseIcon = ({
  fill = "#666",
  variation = "normal",
  ...props
}: SVGProps<SVGSVGElement> & {
  variation?: Variation;
}) => {
  if (variation === "thick") {
    return (
      <svg width={12} height={12} viewBox="0 0 47.971 47.971" {...props}>
        <path
          fill={fill}
          d="M28.228 23.986L47.092 5.122a2.998 2.998 0 000-4.242 2.998 2.998 0 00-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 00-4.242 0 2.998 2.998 0 000 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 104.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 000-4.242L28.228 23.986z"
        />
      </svg>
    );
  }

  return (
    <svg width={12} height={12} viewBox="0 0 64 64" {...props}>
      <path
        fill={fill}
        d="M28.941 31.786L.613 60.114a2.014 2.014 0 102.848 2.849l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59a2.014 2.014 0 001.424-3.439L35.064 31.786 63.41 3.438A2.014 2.014 0 1060.562.589L32.003 29.15 3.441.59A2.015 2.015 0 00.593 3.439l28.348 28.347z"
      />
    </svg>
  );
};

export default CloseIcon;
